import { render, staticRenderFns } from "./GameByBrands.vue?vue&type=template&id=dfa9f80c&scoped=true&"
import script from "./GameByBrands.vue?vue&type=script&lang=js&"
export * from "./GameByBrands.vue?vue&type=script&lang=js&"
import style0 from "./GameByBrands.vue?vue&type=style&index=0&id=dfa9f80c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa9f80c",
  null
  
)

export default component.exports